import qs from 'query-string'
import { parseString, parseStringPromise  } from 'xml2js'
import client from '@/store/client'
import parseData from '../util/parsedata'
import _ from 'lodash'

const getDefaultState = () => {
  return {
    orgMerchantInfo: {
      name: ''
    },
    merchantInfo: {},
    retailData: [],
    headers: [
      {
        text: 'ID',
        sortable: true,
        value: 'ID'
      },
      {
        text: 'Name',
        sortable: true,
        value: 'Name'
      },
      {
        text: 'Row Status',
        sortable: true,
        value: 'RowStatus'
      }
    ]
  }
}

export default {
  namespaced: true,
  state: {
    ...getDefaultState(),
    states: [],
    countries: [],
  },
  actions: {
    SET_FIELD: ({ commit }, data) => {
      commit('setField', data)
    },
    SET_FIELD_OBJ: ({ commit }, data) => {
      commit('setFieldObj', data)
    },
    RESET: ({ commit }) => {
      commit('reset')
    },
    GET_COUNTRIES: async function({commit}){
      try {
        const countryAPI = await client.post('/v1/Lookup.asmx/GetCountries', qs.stringify(this.getters['traceToken']))
        commit('setCountries', await parseData( countryAPI.data ))
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    GET_STATES: async function({commit}, countryID ){
      try {
        const provincesAPI = await client.post('/v1/Lookup.asmx/GetStateProvinces', qs.stringify({...this.getters['traceToken'], countryID }))
        commit('setStates', await parseData( provincesAPI.data ))
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },    
    SET_MERCHANT: async function({ commit, dispatch }, data ) {
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Getting Data',
          subdetail: 'Please wait',
        })
        const apiData = {
          ...this.getters['traceToken'],
          merchantID: data,
        }
        if ( apiData.merchantID && apiData.merchantID != 0 ){
          const retailers = await client.post('/v1/Merchant.asmx/GetRetailersByMerchantID', qs.stringify(apiData) )
          commit('setRetailer', await parseData( retailers.data ))
          const merchantRes = await client.post('/v1/Merchant.asmx/GetMerchant', qs.stringify(apiData) )
          parseString( merchantRes.data, (err, results ) => {
            const merchantInfo = results.content.collection[0].data[0].$
            commit('setMerchant', merchantInfo)
            dispatch('GET_STATES', merchantInfo.CountryCode )
          })
        }
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Redirecting...',
          subdetail: '',
        })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    INSERT_MERCHANT: async function({commit, state}){
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Creating Merchant',
          subdetail: 'Please wait...',
        })
        const APIData = {
          ...this.getters['traceToken'],
          postalCode: state.merchantInfo.PostalCode,
          zipCode4: '',
          zipCode5: state.merchantInfo.PostalCode,
          state: state.merchantInfo.State,
          city: state.merchantInfo.City,
          address1: state.merchantInfo.Address1,
          address2: state.merchantInfo.Address2 || '',
          address3: state.merchantInfo.Address3 || '',
          merchantName: state.merchantInfo.Name,
          countryID: state.merchantInfo.CountryCode,
        }
        const APIRes = await client.post('/v1/Merchant.asmx/InsertMerchant', qs.stringify(APIData))
        const parsedRes = await parseStringPromise(APIRes.data)
        commit('setFieldObj', { obj: 'merchantInfo', key: 'ID', value: parsedRes.content.data[0].$.ID })
        this.dispatch('merchant/SET_MERCHANT', parsedRes.content.data[0].$.ID )
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `New Merchant Created`, color: 'green', delay: 2500 })
      }
      catch (err){
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    UPDATE_MERCHANT: async function({state}){
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating Merchant',
          subdetail: 'Please wait...',
        })
        await client.post('/v1/Merchant.asmx/UpdateMerchant', qs.stringify(this.getters['merchant/updatedInsertAPI']))
        this.dispatch('merchant/SET_MERCHANT', state.merchantInfo.ID )
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Merchant Updated`, color: 'green', delay: 2500 })
      }
      catch (err){
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    }
  },
  getters: {
    merchantChanged: state => !_.isEqual(state.orgMerchantInfo, state.merchantInfo),
    provinceData: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        countryID: 1,
      }
    },
    updatedInsertAPI: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        ...state.merchantInfo,
        merchantID: state.merchantInfo.ID,
        merchantName: state.merchantInfo.Name,
        countryID: state.merchantInfo.CountryCode,
        ZipCode5: state.merchantInfo.PostalCode,
        postalCode: state.merchantInfo.PostalCode
      }
    }
  },
  mutations: {
    setField: function(state, data) {
      state[data.key] = data.value
    },
    setFieldObj: function(state, data) {
      state[data.obj][data.key] = data.value
    },
    reset: function(state) {
      Object.assign(state, getDefaultState())
    },
    setMerchant: function(state, data) {
      state.merchantInfo = data
      state.orgMerchantInfo = _.cloneDeep(data)
    },
    setRetailer: function(state, data) {
      state.retailData = data
    },
    setStates: function(state, data) {
      state.states = data
    },
    setCountries: function(state, data) {
      state.countries = data
    }
  },
}
